import { Message } from '@messageformat/react';
import { ReactElement } from 'react';
import { Col, Row } from '@op/opds.opux';
import { space } from '@op/opds.tokens';
import { ReactComponent as Icon001 } from './Icons/Happiness.svg';
import { ReactComponent as Icon002 } from './Icons/Stress.svg';
import { ReactComponent as Icon003 } from './Icons/Confidence.svg';
import { ReactComponent as Icon004 } from './Icons/Euphoria.svg';
import { ReactComponent as Icon005 } from './Icons/Greed.svg';
import { ReactComponent as Icon006 } from './Icons/Doubt.svg';
import { ReactComponent as Icon007 } from './Icons/Horror.svg';
import { ReactComponent as Icon008 } from './Icons/Denial.svg';
import { ReactComponent as Icon009 } from './Icons/Surrender.svg';
import { ReactComponent as Icon010 } from './Icons/Despair.svg';
import { ReactComponent as Icon011 } from './Icons/Hope.svg';
import { ReactComponent as Icon012 } from './Icons/Relief.svg';
import { ReactComponent as Icon013 } from './Icons/Finish.svg';
import { ReactComponent as Image072 } from '../../images/OP_symbolikuvitus_96_072.svg';
import { ReactComponent as Image96 } from '../../images/no_search_results_96.svg';
import { ReactComponent as Image196 } from '../../images/symbol_misc_notification_01_96.svg';
import { ReactComponent as Image097 } from '../../images/OP_symbolikuvitus_96_097.svg';
import { ReactComponent as Image096 } from '../../images/symbol_ownercustomer_OP_bonuses_96.svg';
import { ReactComponent as ImageAid } from '../../images/symbol_health_band_aid_96.svg';
import styles from './InvestingPath.module.scss';
import { useIsMobile } from '../../util/mediaQuery';

const InvestingPath = (): ReactElement => {
  const isMobile = useIsMobile();

  return (
    <div
      className="investoracademy-path-to-investor-container"
      style={{ marginBottom: '100px' }}
      role="list"
    >
      <div
        className="investoracademy-path-to-investor-row"
        style={{ position: 'relative' }}
        role="listitem"
      >
        <div
          className="investoracademy-path-to-investor-column \
        investoracademy-path-to-investor-oddColumn"
          style={{ paddingBottom: '0px' }}
        >
          <Icon001 className={styles['icon-to-center-bottom']} aria-hidden="true" />
          <Row>
            <Col xs={4} />
            <Col
              xs={10}
              md={12}
              className={styles['investor-text-first']}
              style={{
                verticalAlign: 'middle',
                justifyContent: 'center',
              }}
            >
              <p
                className={styles['investor-textPositive']}
                style={{
                  paddingBottom: space.default,
                  textAlign: 'center',
                }}
              >
                <Message id="course10.investing_path.icon1" />
              </p>
            </Col>
          </Row>
        </div>
      </div>
      {isMobile ? (
        <>
          <div className="investoracademy-path-to-investor-row" role="presentation">
            <div
              className="investoracademy-path-to-investor-column \ investoracademy-investorpath-column"
              role="listitem"
            >
              <Icon002 className={styles['icon-container']} aria-hidden="true" />
              <div className={styles['investor-text']}>
                <p>
                  <Message id="course10.investing_path.icon2" />
                </p>
              </div>
            </div>
            <div
              className="investoracademy-path-to-investor-column \
                    investoracademy-path-to-investor-oddColumn \ investoracademy-investorpath-column"
              role="listitem"
            >
              <Icon003 className={styles['icon-container']} aria-hidden="true" />
              <div className={styles['investor-text']}>
                <p>
                  <Message id="course10.investing_path.icon3" />
                </p>
              </div>
            </div>
          </div>
          <div className="investoracademy-path-to-investor-row" role="presentation">
            <div
              className="investoracademy-path-to-investor-column \ investoracademy-investorpath-column"
              role="listitem"
            >
              <Icon004 className={styles['icon-container']} aria-hidden="true" />
              <div className={styles['investor-text']}>
                <p className={styles['investor-textPositive']}>
                  <Message id="course10.investing_path.icon4" />
                </p>
              </div>
            </div>
            <div
              className="investoracademy-path-to-investor-column \
                    investoracademy-path-to-investor-oddColumn \ investoracademy-investorpath-column"
              role="listitem"
            >
              <Icon005 className={styles['icon-container']} aria-hidden="true" />
              <div className={styles['investor-text']}>
                <p className={styles['investor-textNegative']}>
                  <Message id="course10.investing_path.icon5" />
                </p>
              </div>
            </div>
          </div>
          <div className="investoracademy-path-to-investor-row" role="presentation">
            <div
              className="investoracademy-path-to-investor-column \ investoracademy-investorpath-column"
              role="listitem"
            >
              <Icon006 className={styles['icon-container']} aria-hidden="true" />
              <div className={styles['investor-text']}>
                <p>
                  <Message id="course10.investing_path.icon6" />
                </p>
              </div>
            </div>
            <div
              className="investoracademy-path-to-investor-column \
                    investoracademy-path-to-investor-oddColumn \ investoracademy-investorpath-column"
              role="listitem"
            >
              <Icon007 className={styles['icon-container']} aria-hidden="true" />
              <div className={styles['investor-text']}>
                <p>
                  <Message id="course10.investing_path.icon7" />
                </p>
              </div>
            </div>
          </div>
          <div className="investoracademy-path-to-investor-row" role="presentation">
            <div
              className="investoracademy-path-to-investor-column \ investoracademy-investorpath-column"
              role="listitem"
            >
              <Icon008 className={styles['icon-container']} aria-hidden="true" />
              <div className={styles['investor-text']}>
                <p>
                  <Message id="course10.investing_path.icon8" />
                </p>
              </div>
            </div>
            <div
              className="investoracademy-path-to-investor-column \
                    investoracademy-path-to-investor-oddColumn \ investoracademy-investorpath-column"
              role="listitem"
            >
              <Icon009 className={styles['icon-container']} aria-hidden="true" />
              <div className={styles['investor-text']}>
                <p>
                  <Message id="course10.investing_path.icon9" />
                </p>
              </div>
            </div>
          </div>
          <div className="investoracademy-path-to-investor-row" role="presentation">
            <div
              className="investoracademy-path-to-investor-column \ investoracademy-investorpath-column"
              role="listitem"
            >
              <Icon010 className={styles['icon-container']} aria-hidden="true" />
              <div className={styles['investor-text']}>
                <p className={styles['investor-textNegative']}>
                  <Message id="course10.investing_path.icon10" />
                </p>
              </div>
            </div>
            <div
              className="investoracademy-path-to-investor-column \
                    investoracademy-path-to-investor-oddColumn \ investoracademy-investorpath-column"
              role="listitem"
            >
              <Icon011 className={styles['icon-container']} aria-hidden="true" />
              <div className={styles['investor-text']}>
                <p>
                  <Message id="course10.investing_path.icon11" />
                </p>
              </div>
            </div>
          </div>
          <div className="investoracademy-path-to-investor-row" role="presentation">
            <div
              className="investoracademy-path-to-investor-column \ investoracademy-investorpath-column"
              role="listitem"
            >
              <Icon012 className={styles['icon-container']} aria-hidden="true" />
              <div className={styles['investor-text']}>
                <p>
                  <Message id="course10.investing_path.icon12" />
                </p>
              </div>
            </div>
            <div
              className="investoracademy-path-to-investor-column \
                    investoracademy-path-to-investor-oddColumn \ investoracademy-investorpath-column"
              role="listitem"
            >
              <Icon001 className={styles['icon-container']} aria-hidden="true" />
              <Icon013 style={{ transform: 'rotate(180deg)' }} aria-hidden="true" />
              <div className={styles['investor-text']}>
                <p className={styles['investor-textPositive']}>
                  <Message id="course10.investing_path.icon13" />
                </p>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="investoracademy-path-to-investor-row" role="presentation">
            <div
              className="investoracademy-path-to-investor-column \
              investoracademy-path-to-investor-arc"
              style={{
                order: 2,
                padding: `${space.xxxxl} ${space.xl}`,
                position: 'relative',
                minHeight: '470px',
              }}
              role="listitem"
            >
              <Icon002
                className={styles['icon-to-right-center-top']}
                aria-hidden="true"
              />
              <div
                className={`${styles['investor-text']} ${styles['top-right-center-text']}`}
              >
                <p>
                  <Message id="course10.investing_path.icon2" />
                </p>
              </div>
              <Image96 className={styles['image-right-top']} aria-hidden="true" />
            </div>
            <div
              className="investoracademy-path-to-investor-column"
              style={{ padding: `${space.default} ${space.xl}` }}
              role="presentation"
            >
              <Image072 className={styles['image-left-top']} aria-hidden="true" />
              <div
                className="investoracademy-path-to-investor-loopToLeft"
                style={{
                  order: '1',
                  height: '70%',
                  position: 'absolute',
                  bottom: '0px',
                  left: '0px',
                  width: '100%',
                }}
                aria-hidden="true"
              />
              <Icon003 className={styles['icon-to-left-bottom']} aria-hidden="true" />
              <div
                className={`${styles['investor-text']} ${styles['top-left-bottom-text']}`}
                role="listitem"
              >
                <p>
                  <Message id="course10.investing_path.icon3" />
                </p>
              </div>
              <Icon004 className={styles['icon-to-left-center']} aria-hidden="true" />
              <div
                className={`${styles['investor-text']} ${styles['top-left-center-text']}`}
                role="listitem"
              >
                <p className={styles['investor-textPositive']}>
                  <Message id="course10.investing_path.icon4" />
                </p>
              </div>
              <Icon005 className={styles['icon-to-left-top']} aria-hidden="true" />
              <div
                className={`${styles['investor-text']} ${styles['top-left-top-text']}`}
                role="listitem"
              >
                <p className={styles['investor-textNegative']}>
                  <Message id="course10.investing_path.icon5" />
                </p>
              </div>
              <Icon006 className={styles['icon-to-center-line-top']} aria-hidden="true" />
              <div
                className={`${styles['investor-text']} ${styles['top-center-line-text']}`}
                role="listitem"
              >
                <p>
                  <Message id="course10.investing_path.icon6" />
                </p>
              </div>
            </div>
          </div>
          <div className="investoracademy-path-to-investor-row" role="listitem">
            <div
              className="investoracademy-path-to-investor-column \
            investoracademy-path-to-investor-borderRight"
            >
              <Icon007
                className={styles['icon-to-center-line-first']}
                aria-hidden="true"
              />
              <Image196 className={styles['image-center-line']} aria-hidden="true" />
            </div>
            <div className="investoracademy-path-to-investor-column">
              <div
                className={`${styles['investor-text']} ${styles['center-line-text-first']}`}
              >
                <p>
                  <Message id="course10.investing_path.icon7" />
                </p>
              </div>
            </div>
          </div>
          <div className="investoracademy-path-to-investor-row" role="listitem">
            <div
              className="investoracademy-path-to-investor-column \
        investoracademy-path-to-investor-borderRight \
        investoracademy-path-to-investor-textToRight"
            >
              <Icon008
                className={styles['icon-to-center-line-second']}
                aria-hidden="true"
              />
              <div className={styles['investor-text']}>
                <p>
                  <Message id="course10.investing_path.icon8" />
                </p>
              </div>
            </div>
            <div
              className="investoracademy-path-to-investor-column"
              style={{ minHeight: '270px' }}
              aria-hidden="true"
            />
          </div>
          <div className="investoracademy-path-to-investor-row" role="presentation">
            <div
              className="investoracademy-path-to-investor-column \
          investoracademy-path-to-investor-loopToRight"
              style={{ order: '2', minHeight: '350px' }}
              role="presentation"
            >
              <Image097 className={styles['image-right-bottom']} aria-hidden="true" />
              <Icon009
                className={styles['icon-to-center-line-bottom']}
                aria-hidden="true"
              />

              <div
                className={`${styles['investor-text']} ${styles['bottom-center-line-text']}`}
                role="listitem"
              >
                <p>
                  <Message id="course10.investing_path.icon9" />
                </p>
              </div>
              <Icon010 className={styles['icon-to-right-bottom']} aria-hidden="true" />
              <div
                className={`${styles['investor-text']} ${styles['bottom-right-bottom-text']}`}
                role="listitem"
              >
                <p className={styles['investor-textNegative']}>
                  <Message id="course10.investing_path.icon10" />
                </p>
              </div>
              <Icon011
                className={styles['icon-to-right-center-bottom']}
                aria-hidden="true"
              />
              <div
                className={`${styles['investor-text']} ${styles['bottom-right-center-text']}`}
                role="listitem"
              >
                <p>
                  <Message id="course10.investing_path.icon11" />
                </p>
              </div>
              <Icon012 className={styles['icon-to-right-top']} aria-hidden="true" />
              <div
                className={`${styles['investor-text']} ${styles['bottom-right-top-text']}`}
                role="listitem"
              >
                <p>
                  <Message id="course10.investing_path.icon12" />
                </p>
              </div>
            </div>
            <div
              className="investoracademy-path-to-investor-column"
              style={{ order: '1' }}
              role="listitem"
            >
              <Image096 className={styles['image-left-finish']} aria-hidden="true" />
              <ImageAid className={styles['image-left-bottom']} aria-hidden="true" />
              <div className={styles['halfArc-bottom']} aria-hidden="true" />
              <div className={styles['icon-to-left-finish']} aria-hidden="true">
                <Icon013 aria-hidden="true" />
                <Icon001 aria-hidden="true" />
              </div>
              <div
                className={`${styles['investor-text']} ${styles['bottom-left-top-text']}`}
              >
                <p className={styles['investor-textPositive']}>
                  <Message id="course10.investing_path.icon13" />
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default InvestingPath;
